import { eAssetType } from "../Asset";
import { eInvestorType } from "../Users";

export enum eProviderId {
  REUTERS = "1",
  ESTADAO = "69",
  BRAZILIAN_MIXED = "7",
  AGENCIA_BRAZIL = "26",
  CRIPTO_FACIL = "48",
  PANORAMA_CRIPTO = "75",
}

export interface News {
  newsId?: number;
  name: string;
  content: string;
  date: string;
  dateTimestamp: number;
  dataID?: any;
  providerID: eProviderId;
  providerName: string;
  image: string;
  linkExternal: string;
}

export interface AnalysisResult {
  impressions: any;
  indications: any;
}

export interface ReportablePoints {
  encoded_id: string;
  type: eAssetType;
  investor_type: eInvestorType;
  technical: number;
  fundamental: number;
  others: number;
  total_points: number;
}

export interface CountedPoints {
  fundamental: number;
  technical: number;
  others: number;
  total_points: number;
}
